export const minSupportedWidth = 0

export const breakpointsNoUnit = {
  XS: 900,
  S: 1024,
  M: 1366,
  L: 1920,
  XL: 3840,
}

export type BreakpointKey = keyof typeof breakpointsNoUnit

const mapBreakpoints = <T>(fn: (value: number) => T) =>
  (Object.keys(breakpointsNoUnit) as BreakpointKey[]).reduce(
    (result, key) => ({ ...result, [key]: fn(breakpointsNoUnit[key]) }),
    {} as Record<BreakpointKey, T>,
  )

export const breakpoints = mapBreakpoints(value => `${value}px`)

export const breakpointsCross = mapBreakpoints(value => ({
  max: `${value - 1}px`,
  min: `${value}px`,
  over: `${value + 1}px`,
}))
